import React from 'react';
import './VideoSelfieRecovery.scss';
import { NotSupportedMessage } from './NotSupportedMessage/NotSupportedMessage';
import { getIsXpressIdSupported } from 'utilities/video/xpressIdCompatibility';
import { VideoSelfie } from './VideoSelfie/VideoSelfie';
import { useAddClassNameToAppOnMount } from 'hooks/useAddClassNameToAppOnMount';
import { useHideHeaderOnMount } from 'hooks/useHideHeaderOnMount';
import { withHeaderContext } from 'hocs/withHeaderContext/withHeaderContext';

export const VideoSelfieRecoveryComponent = ({ clientId, token, headerActions }) => {
    useAddClassNameToAppOnMount('full-height-videoselfie-view');
    useHideHeaderOnMount(headerActions);
    const isXpressIdSupported = getIsXpressIdSupported();

    if (!isXpressIdSupported) return <NotSupportedMessage />;

    return <VideoSelfie clientId={clientId} token={token} />;
};

export const VideoSelfieRecovery = withHeaderContext(VideoSelfieRecoveryComponent);
